import React from 'react';
import { Edit, SimpleForm, BooleanInput } from 'react-admin';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { DateInput } from '../../../ui/custom-date-time-pickers';
import CustomTextField from '../../../ui/custom-text-field';
import { ContentPageSX } from '../../../styled/custom';
import { minLength, hasValue, validDate } from '../../../utils/schemas';
import EditTitle from '../../../ui/edit-title';
import CustomEditToolbar from '../../../ui/custom-edit-toolbar';

const Schema = Yup.object(
{
  name: minLength(3, 'Digite o nome'),
  number_inserts: hasValue('Digite a quantidade de inserções diárias'),
  contract_validity: validDate('Selecione a validade do contrato')
});

const ClientEdit = () => (
  <Edit
    title={ <EditTitle subtitle="Editar Cliente: " source="name" /> }
    redirect="list"
    mutationMode="pessimistic"
    sx={ContentPageSX}>
    <SimpleForm
      noValidate
      toolbar={ <CustomEditToolbar /> }
      resolver={yupResolver(Schema)}>
      <CustomTextField source="id" label="Id" disabled />
      <CustomTextField name="name" label="Nome" fullWidth />
      <CustomTextField type="number" name="number_inserts" label="Inserções Diárias" min={0} fullWidth isRequired />
      <DateInput source="contract_validity" label="Validade do Contrato" fullWidth isRequired />
      <BooleanInput source="active" label="Ativo" />
    </SimpleForm>
  </Edit>
);

export default ClientEdit;
